import React from 'react';
import { motion } from 'framer-motion';
import { Github } from 'lucide-react';

const Footer = () => {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="relative mt-20"
    >
      <div className="relative bg-slate-100 dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Center aligned content */}
          <div className="text-center space-y-6">
            {/* Logo and Project Name */}
            <div className="flex justify-center">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">M</span>
              </div>
            </div>

            {/* Copyright and Team */}
            <div className="space-y-2">
              <p className="text-slate-900 dark:text-slate-100 text-lg font-semibold">
                © 2025 MED-Net Project
              </p>
              <p className="text-slate-600 dark:text-slate-400 text-sm">
                Built by Team KMEC students
              </p>
            </div>

            {/* Repository Link */}
            <a
              href="https://github.com/EhsaasN/DUAL_TCN_ATTN"
              target="_blank"
              rel="noopener noreferrer"
              title="https://github.com/EhsaasN/DUAL_TCN_ATTN.git"
              className="inline-flex items-center space-x-2 text-slate-600 dark:text-slate-400 hover:text-teal-600 dark:hover:text-teal-400"
            >
              <Github size={20} />
              <span className="text-sm font-medium">Repository</span>
            </a>

            {/* Project Description */}
            <div className="space-y-2 max-w-2xl mx-auto">
              <p className="text-slate-800 dark:text-slate-200 text-sm leading-relaxed">
                Multi-Scale Enhanced Dual Temporal Convolution Attention Network for Anomaly Detection in Multivariate Time Series Data
              </p>
              <p className="text-slate-600 dark:text-slate-400 text-sm font-medium">
                Advanced Research Project
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
